/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-type is a library for typechecking of props
import PropTypes from "prop-types";

// formik components
import { ErrorMessage, Field } from "formik";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";
import SoftInput from "components/SoftComponents/SoftInput";

function FormField({ label, name, alignment = "flex-start", border = null, ...rest }) {
  return (
    <SoftBox mb={1.5}>
      <SoftBox mb={1} ml={alignment == "flex-start" ? 0.5 : 0} lineHeight={0} display="flex" alignItems={alignment} flexDirection="column">
        <SoftTypography
          component="label"
          variant="caption"
          fontWeight="bold"
          textTransform="capitalize"
        >
          {label}
        </SoftTypography>
      </SoftBox>
      {!border ? (
        <Field {...rest} name={name} as={SoftInput} />
      ) : (
        <Field {...rest} name={name} as={SoftInput} sx={{ border }} />
      )}
      <SoftBox>
        <SoftTypography component="div" variant="caption" color="error">
          <ErrorMessage name={name} />
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
}

// typechecking props for FormField
FormField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default FormField;
